const LEAGUE_SINGULAR = 'League';
const LEAGUE_PLURAL = 'Leagues';

const PICKLEBALL_LEAGUES_PRODUCT_NAME = 'Pickleball Leagues';
const PICKLEBALL_LEAGUE_PRODUCT_NAME = 'Pickleball League';

export const LEAGUE_LABELS = {
  singular: LEAGUE_SINGULAR,
  plural: LEAGUE_PLURAL,
  singularLower: LEAGUE_SINGULAR.toLowerCase(),
  pluralLower: LEAGUE_PLURAL.toLowerCase(),
  product: PICKLEBALL_LEAGUES_PRODUCT_NAME,
  productSingular: PICKLEBALL_LEAGUE_PRODUCT_NAME,
} as const;

export const APR_LABELS = {
  short: 'APR',
  long: 'Amateur Pickleball Rankings',
  longSingular: 'Amateur Pickleball Ranking',
  siteName: 'AmateurPickleballRankings.com',
  site: 'amateurpickleballrankings',
  domainDev: 'amateurpickleballrankings.dev',
  domainTest: 'amateurpickleballrankingstest.net',
  domainProd: 'amateurpickleballrankings.com',
} as const;
